document.addEventListener("DOMContentLoaded", function () {
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const today = new Date();
  const day = today.getDate();
  const currentMonth = today.getMonth();
  const monthName = monthNames[currentMonth];

  const maxStock = 60;
  const minStock = 4;
  const decreasePerDay = 2;

  let stockLeft = Math.max(maxStock - (day * decreasePerDay), minStock);

  const stockEl = document.getElementById("stock-message");
  if (stockEl) {
    stockEl.textContent = `Only ${stockLeft} bundles left for ${monthName}. Free shipping included.`;
  }
});
